import { render, staticRenderFns } from "./PagoError.vue?vue&type=template&id=1c3e376a"
import script from "./PagoError.vue?vue&type=script&lang=js"
export * from "./PagoError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports